module.exports = __webpack_public_path__ + "media/application/images/ctaspm-14e5cf797cfc7aa8bf7863f9e8be45b6.png";